import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatChipsModule } from '@angular/material/chips'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { SatPopoverModule } from '@ncstate/sat-popover'
import { TranslateModule } from '@ngx-translate/core'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { BreadcrumbModule } from '../breadcrumb'
import { ChargesDialogModule } from '../charges-dialog'
import { ChargesTableFormModule } from '../charges-table-selector'
import { CharityCareSummaryComponent } from '../charity-care-summary/charity-care-summary.component'
import { DateFieldModule } from '../date-selector'
import { EligibilityCardModule } from '../eligibility-card'
import { EstimateTemplateMenuComponent } from '../estimate-template-menu'
import { ExpandableCardComponent } from '../expandable-card/expandable-card.component'
import { FacilitySelectorModule } from '../facility-selector'
import { HistoryDialogModule } from '../history-dialog'
import { InsurancesCardModule } from '../insurances-card'
import { ChargeCardModule } from '../payments/charge-card/charge-card.module'
import { PhoneFieldModule } from '../phone-field'
import { PullEligibilityDialogModule } from '../pull-eligibility-dialog'
import { SendContactEditDialogModule } from '../send-contact-edit-dialog'
import { CollectPaymentButtonComponent } from './collect-payment-button/collect-payment-button.component'
import { CollectPaymentDialogComponent } from './collect-payment-button/collect-payment-dialog.component'
import { EstimateComponent } from './estimate.component'
import { EstimateBenefitsComponent } from './estimate-benefits/estimate-benefits.component'
import { EstimateChargesComponent } from './estimate-charges/estimate-charges.component'
import { EstimateHistoryDialogComponent } from './estimate-history'
import { EstimatePrintInvoiceButtonComponent } from './estimate-print-invoice-button'
import { EstimateSendInvoiceComponent } from './estimate-send-invoice'
import { EstimateSummaryComponent } from './estimate-summary/estimate-summary.component'
import { EstimateTemplateDialogComponent } from './estimate-template-dialog/estimate-template-dialog.component'
import { ShopperInsuranceCardComponent } from './shopper-insurance-card/shopper-insurance-card.component'
import { ShopperPatientFormComponent } from './shopper-patient-form/shopper-patient-form.component'

@NgModule({
  imports: [
    CommonModule,
    BreadcrumbModule,
    ChargesDialogModule,
    ChargesTableFormModule,
    DirectivesModule,
    FacilitySelectorModule,
    FlexLayoutModule,
    FormsModule,
    HistoryDialogModule,
    InsurancesCardModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatSnackBarModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    PipesModule,
    ChargeCardModule,
    ReactiveFormsModule,
    RouterModule,
    SatPopoverModule,
    SendContactEditDialogModule,
    TranslateModule,
    CharityCareSummaryComponent,
    EstimateTemplateMenuComponent,
    ExpandableCardComponent,
    PhoneFieldModule,
    PullEligibilityDialogModule,
    DateFieldModule,
    EligibilityCardModule,
  ],
  declarations: [
    EstimateComponent,
    EstimateChargesComponent,
    EstimateBenefitsComponent,
    EstimateSummaryComponent,
    EstimateTemplateDialogComponent,
    EstimateSendInvoiceComponent,
    EstimatePrintInvoiceButtonComponent,
    CollectPaymentButtonComponent,
    CollectPaymentDialogComponent,
    EstimateHistoryDialogComponent,
    ShopperInsuranceCardComponent,
    ShopperPatientFormComponent,
  ],
  exports: [EstimateComponent],
})
export class LiabilityEstimatorModule {}
